'use client'

import type { FC } from 'react'
import CustomTimePicker from 'components/datetime/CustomTimePicker'
import { Label } from 'ui/label'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const TimeField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <CustomTimePicker
                name={field.name}
                value={(value as string) || ''}
                onChange={time => onChange(field.name, time, field)}
            />
        </FieldWrapper>
    )
}

export default TimeField
